import AccordionItem from 'components/v2/common/AccordionItem';
import DisableProcessSummary from "./DisableProcessSummary";
import DisableProcessDetails from "./DisableProcessDetails";

export default function DisableProcess({disableProcess}) {
    return (
        <AccordionItem
                key={disableProcess.id}
                summaryComponent={<DisableProcessSummary disableProcess={disableProcess}/>}>
            <DisableProcessDetails disableProcess={disableProcess} />
        </AccordionItem>
    );
}
